import { Box, Grid, Typography } from '@material-ui/core';
import { Add, LiveHelp } from '@material-ui/icons';
import { FieldArray, Form, Formik, FormikProps } from 'formik';
import React, { useState } from 'react';
import { ConsoleActionButton } from '../../common/ConsoleActionButton';
import { useAdminConsoleActions } from '../../admin-console-actions';
import { AddApplicationQuestionDialog } from './AddApplicationQuestionDialog';
import { ApplicationQuestionsFormValues } from './application-questions-model';
import { ApplicationQuestionListFieldSection } from './ApplicationQuestionListFieldSection';

type ApplicationQuestionEditFormType = {
  initialValues: ApplicationQuestionsFormValues;
  refetchQuestions?: () => void;
};

export const ApplicationQuestionEditForm = ({ initialValues, refetchQuestions }: ApplicationQuestionEditFormType) => {
  const [openAddDialog, setOpenAddDialog] = useState<boolean>(false);
  const { runSaveActivityApplicationQuestions } = useAdminConsoleActions();

  return (
    <Box>
      <Formik
        enableReinitialize
        initialValues={{
          ...initialValues,
          applicationQuestions: initialValues.applicationQuestions.sort((a, b) => (a.order < b.order ? -1 : 1)),
        }}
        onSubmit={(values) => {
          runSaveActivityApplicationQuestions({ questions: values.applicationQuestions });
        }}
      >
        {(formik: FormikProps<ApplicationQuestionsFormValues>) => (
          <Form>
            <FieldArray name='applicationQuestions'>
              {(arrayHelpers) => (
                <>
                  <Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <Box>
                      <Typography style={{ fontWeight: 600, fontSize: '16px', display: 'flex', alignItems: 'center' }}>
                        <LiveHelp style={{ fontSize: '14px', paddingRight: '5px' }} /> Activity Application Questions
                      </Typography>
                      <Typography variant={'body2'} style={{ fontSize: '14px', color: '#808080' }}>
                        {
                          'Volunteers answer these when applying to an activity that requires approval. Answers are shown to admins during review. Open activities skip them.'
                        }
                      </Typography>
                    </Box>
                    <ConsoleActionButton
                      size='small'
                      variant='contained'
                      color='primary'
                      aria-controls='options-menu'
                      aria-haspopup='true'
                      startIcon={<Add />}
                      style={{
                        border: '1px solid transparent',
                        boxSizing: 'border-box',
                        borderRadius: '4px',
                        padding: '6px 12px',
                        marginLeft: '10px',
                        marginTop: '2px',
                        color: '#fff',
                      }}
                      onClick={() => {
                        setOpenAddDialog(true);
                      }}
                    >
                      {'Add'}
                    </ConsoleActionButton>
                  </Box>

                  <Grid item xs>
                    <ApplicationQuestionListFieldSection
                      arrayHelpers={arrayHelpers}
                      onSubmit={() => formik.submitForm()}
                    />
                  </Grid>

                  <AddApplicationQuestionDialog
                    open={openAddDialog}
                    onClose={() => setOpenAddDialog(false)}
                    refetchQuestions={refetchQuestions}
                  />
                </>
              )}
            </FieldArray>
          </Form>
        )}
      </Formik>
    </Box>
  );
};
